<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Manage Users</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <router-link
              :to="add_staff()"
              type="button"
              class="btn btn-info btn-rounded"
              style="background-color: #AC8400; border-color: #AC8400; width: 100px;"
              >Add</router-link
            >

            <br /><br />

            <div class="table-responsive">
              <table
                id="users_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    <th>Position</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.user.name }}</td>
                    <td>{{ user.user.email }}</td>
                    <td>{{ user.user.username }}</td>
                    <td>{{ user.position }}</td>
                    <td style="text-align: left;">
                      <div
                        v-for="(value, vindex) in user.user.roles"
                        :key="vindex"
                      >
                        - {{ value.name }}
                      </div>
                    </td>
                    <td>
                      <div v-if="user.user.active == 1">
                        Active
                      </div>
                      <div v-else>
                        Not Active
                      </div>
                    </td>
                    <td>
                      <router-link
                        :to="edit_staff(user.id)"
                        type="button"
                        class="btn btn-info btn-rounded btn-block"
                        style="background-color: #AC8400; border-color: #AC8400;"
                        >Edit</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "manage-users",
  components: {},

  data() {
    return {
      users: [
        {
          user: [{ name: "", email: "" }]
        },
        { position: "" }
      ]
    };
  },

  methods: {
    loadUsers() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/staffs/all", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.users = res.data;
          });
      }
    },

    add_staff() {
      return "/add_staff/";
    },

    edit_staff(id) {
      return "/edit_staff/" + id;
    }
  },

  mounted() {
    this.loadUsers();

    setTimeout(function() {
      $("#users_tbl").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6]
            }
          }
        ]
      });
    }, 1000);
  }
};
</script>
